module.exports = __webpack_public_path__ + "media/images/svg/logotype-eclectick-3ec905cb534c763052cce460d9e4af69.svg";